export default __webpack_public_path__ + "static/media/spinner-1s-58px.66698f13.svg";